module.exports = __webpack_public_path__ + "img/Global_Compact_Labour.d577fba9.svg";